module.exports = __webpack_public_path__ + "img/descargar.35cb8295.svg";